import { generateRandomString } from 'lib/utils/string';

export default {
  props: {
    value: String,
    placeholder: String,
    type: {
      type: String,
      default: () => 'text',
    },
    maxlength: {
      type: Number,
      default: () => 50,
    },
    disabled: {
      type: Boolean,
      default: () => false,
    },
    autofocus: {
      type: Boolean,
      default: () => false,
    },
    error: {
      type: Boolean,
      default: () => false,
    },
  },
  data() {
    return {
      focused: false,
      getInputRef: `input-${this.type}-${generateRandomString()}`,
    };
  },
  computed: {
    computedClasses() {
      return {
        [this.$style.invalid]: this.error,
        [this.$style.focused]: this.focused,
        [this.$style.disabled]: this.disabled,
      };
    },
  },
  watch: {
    autofocus: {
      immediate: true,
      async handler(val) {
        if (val) {
          await this.$nextTick;
          this.handleFocus();
        }
      },
    },
    focused: {
      handler(val) {
        if (val) {
          this.$refs[this.getInputRef].$el.focus();
        }
      },
    },
  },
  methods: {
    selectOnInput() {
      this.$refs[this.getInputRef].$el.select();
      this.$refs[this.getInputRef].$el.focus();
    },
    handleInput(value) {
      this.$emit('input', value);
    },
    handleFocus() {
      if (this.disabled) {
        return;
      }

      this.focused = true;
      this.$emit('focus');
    },
    handleBlur() {
      this.focused = false;
      this.$emit('blur');
    },
    handleSubmit(event) {
      this.$emit('submit');

      if (this.$validate.isObjectWithFields(event, ['target'])) {
        event.target.blur();
      }
    },
  },
};
